export const isHomepage =
  typeof window !== 'undefined' && window.location.pathname === '/'
